import Http from "@/Http/Request";
import { LogoutResponse } from "./types";
import { useMutation } from "react-query";

const logout = async () => {
	
	const { data } = await Http({
		method: 'GET',
		url: 'logoutUserApi',
	});
	return data;
};


const useLogout = () => {
	const mutation = useMutation<LogoutResponse, Error>({
		mutationKey: ['logout'],
		mutationFn:  logout
	})
  return mutation
}

export default useLogout